import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '3rem', textAlign: 'center', maxWidth: 500, margin: '4rem auto',
          background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}>
          <h2 style={{ color: '#e74c3c', marginBottom: '1rem' }}>Une erreur est survenue</h2>
          <p style={{ color: '#666', marginBottom: '1.5rem' }}>
            L'application a rencontre un probleme inattendu.
          </p>
          <button
            onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
            style={{
              background: '#3498db', color: '#fff', border: 'none', padding: '0.6rem 1.5rem',
              borderRadius: 4, cursor: 'pointer', fontSize: '0.9rem',
            }}
          >
            Recharger la page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
